var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRivalTypingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.82 54.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #25282d;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #9a0df9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.69,26.27c-.63,0-1.14.51-1.14,1.14,0,13.86-11.28,25.14-25.14,25.14S2.27,41.27,2.27,27.41,13.55,2.27,27.41,2.27c7.87,0,15.13,3.61,19.88,9.76l-5.36-1.04c-.62-.12-1.21.28-1.33.9-.12.62.28,1.21.9,1.33l8.12,1.57c.07.01.14.02.22.02.24,0,.48-.08.68-.22.26-.19.42-.48.45-.79l.91-8.71c.07-.62-.39-1.18-1.01-1.25-.63-.07-1.18.39-1.25,1.01l-.6,5.71C43.84,3.91,35.96,0,27.41,0,12.3,0,0,12.3,0,27.41s12.3,27.41,27.41,27.41,27.41-12.3,27.41-27.41c0-.63-.51-1.14-1.14-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.03,14.73c-.31-.22-.68-.08-.89.33l-7.14,13.76c-.18.35-.22.83-.09,1.23.12.41.39.66.68.66h4.77l-.78,8.48c-.05.52.14,1.03.45,1.24.09.06.19.09.29.09.23,0,.45-.16.59-.45l6.98-13.98c.18-.35.21-.83.08-1.23-.13-.4-.39-.65-.67-.65h-4.73l.9-8.23c.06-.52-.12-1.04-.43-1.26ZM33.76,26.54l-4.31,8.63.5-5.47c.03-.33-.03-.67-.18-.93-.14-.25-.35-.4-.57-.4h-4.07l4.36-8.4-.57,5.2c-.04.34.02.68.17.95.14.26.35.41.57.41h4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.41,7.83c-10.8,0-19.59,8.79-19.59,19.59s8.79,19.58,19.59,19.58,19.59-8.79,19.59-19.58c0-.63-.51-1.14-1.14-1.14s-1.14.51-1.14,1.14c0,9.55-7.77,17.31-17.31,17.31s-17.31-7.77-17.31-17.31,7.77-17.31,17.31-17.31c.63,0,1.14-.51,1.14-1.14s-.51-1.14-1.14-1.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRivalTypingIcon);
export default __webpack_public_path__ + "static/media/rival-typing-icon.a8914bfffcd071577a6a23bde26bc0a8.svg";
export { ForwardRef as ReactComponent };